import React, { Component } from 'react'
import dynamic from 'next/dynamic'

import { PLANS } from 'services/config'
import LayoutAdmin from 'components/Layout/Admin'

const Prospections = dynamic(() => import('components/Bin/Prospections'), {
  ssr: false,
})

const DashboardContent = dynamic(() => import('components/DashboardContent'), {
  ssr: false,
})

class BinProspections extends Component {
  render() {
    const {
      filters,
      url: { query, pathname }
    } = this.props
    const { page = 1 } = query
    return (
      <LayoutAdmin
        pageRoles={['BROKER']}
        pagePlans={[
          PLANS.FULL_SERVICE,
          PLANS.IN_HOUSE_FULL,
          PLANS.AFFILIATE,
          PLANS.LITE,
          PLANS.IN_HOUSE_RENT,
          PLANS.IN_HOUSE_SELL,
        ]}
        urlData={{ query, pathname }}
        title="Prospecciones para tus clientes"
      >
        <DashboardContent>
          <Prospections  page={page}/>
        </DashboardContent>
      </LayoutAdmin>
    )
  }
}

BinProspections.getInitialProps = context => {
  return {}
}

export default BinProspections
